import { render, staticRenderFns } from "./yeni2.vue?vue&type=template&id=58c06ac0&scoped=true&"
import script from "./yeni2.vue?vue&type=script&lang=js&"
export * from "./yeni2.vue?vue&type=script&lang=js&"
import style0 from "./yeni2.vue?vue&type=style&index=0&id=58c06ac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c06ac0",
  null
  
)

export default component.exports